import React from 'react';
import { cn } from '../utils/classUtils';

export interface CardProps {
  title?: string;
  bottomAction?: string | React.ReactElement;
  onBottomActionClick?(): void;
  LeftComponent?: React.ReactElement;
  RightComponent?: React.ReactElement;
  BottomComponent?: React.ReactElement;
  hideBottomAction?: boolean;
  variant?: 'border' | 'no-border';
  resize?: boolean;
  testId?: string;
  focusId?: string;
  titleAdjacentComponent?: React.ReactElement;
  titleIconPlacement?: 'left' | 'right';
  children: React.ReactNode;
}

const Card: React.FC<CardProps> = ({
  bottomAction,
  BottomComponent,
  onBottomActionClick,
  title,
  LeftComponent,
  RightComponent,
  hideBottomAction = false,
  children,
  variant = 'border',
  resize = false,
  testId = 'zen-card',
  titleAdjacentComponent,
  titleIconPlacement = 'right',
}) => {
  return (
    <div
      data-testid={testId}
      className={cn(
        'flex flex-col relative',
        variant === 'border' ? 'border border-gray-200' : '',
        'rounded-lg',
        !resize ? 'min-h-full' : 'h-auto w-full',
      )}
    >
      {title && (
        <div className='flex flex-wrap justify-between items-center py-3 px-4 bg-gray-100 rounded-t-lg'>
          <p className='flex items-center'>
            {!!LeftComponent && <span className='mr-1'>{LeftComponent}</span>}
            <span
              className={cn(
                'flex font-medium items-center font-inter text-base leading-[22px] text-primary-dark',
                titleIconPlacement === 'right'
                  ? 'flex-row'
                  : 'flex-row-reverse',
              )}
            >
              {title}
              {titleAdjacentComponent && titleAdjacentComponent}
            </span>
          </p>
          <div className='ml-auto'>{RightComponent}</div>
        </div>
      )}
      <div>{children}</div>
      {BottomComponent
        ? BottomComponent
        : !hideBottomAction &&
          bottomAction && (
            <button
              onClick={onBottomActionClick}
              className='text-primary-blue font-primary-regular focus:outline-none hover:opacity-70 px-4 py-2 w-full'
            >
              {bottomAction}
            </button>
          )}
    </div>
  );
};

export default Card;
